<h2>Profile</h2>
<mat-card appearance="outlined" class="sharp global" *ngIf="profile">
    <mat-card-content>
        <h3>{{profile.member?.given_nm}} {{profile.member?.last_nm}}</h3>
        <div class="profile-box">
            <div class="profile-box-container">
                <div class="item">
                    <mat-form-field appearance="fill">
                        <mat-label>First Name</mat-label>
                        <input aria-label="First Name" matInput readonly="true" [value]="profile.member?.given_nm">
                    </mat-form-field>
                </div>
                <div class="item">
                    <mat-form-field appearance="fill">
                        <mat-label>Last Name</mat-label>
                        <input aria-label="Last Name" matInput readonly="true" [value]="profile.member?.last_nm">
                    </mat-form-field>
                </div>
                <div class="item">
                    <mat-form-field appearance="fill">
                        <mat-label>Name of Organization</mat-label>
                        <input aria-label="Name of Organization" matInput readonly="true" [value]="profile.primary_location?.company_nm">
                    </mat-form-field>
                </div>
                <div class="item">
                    <mat-form-field appearance="fill">
                        <mat-label>Lawyer ID Number</mat-label>
                        <input aria-label="Lawyer ID Number" matInput readonly="true" [value]="profile.member?.member_id">
                    </mat-form-field>
                </div>
                <div class="item">
                    <mat-form-field appearance="fill">
                        <mat-label>Preferred Email Address</mat-label>
                        <input aria-label="Preferred Email Address" matInput readonly="true" [value]="profile.member?.email_no">
                    </mat-form-field>
                </div>
                <div class="item">
                    <mat-form-field appearance="fill">
                        <mat-label>Location</mat-label>
                        <input aria-label="Location" matInput readonly="true" [value]="profile.primary_location?.city_nm">
                    </mat-form-field>
                </div>
            </div>
            <h4>Practice Areas</h4>
            <ul class="practice-area">
                <li *ngFor="let area of practiceAreas?.memberAOP">{{area.practice_area?.area_class}}</li>
            </ul>
            <div class="call">Year of Call: {{cdate}}</div>
            <div class="clearfix"></div>
        </div>
        <p>If any of the above information is incorrect you will need to close this CPD tool to edit your personal information in the Lawyer Portal. <button class="link-return" (click)="return()">Close the CPD Tool and open the Lawyer Portal</button>.</p>
    </mat-card-content>
</mat-card>
